// store/index.js
import { createStore } from 'vuex';
import competition from './modules/competition';
import competition_users from './modules/competition_users';
import user from './modules/user';
import round from './modules/round';
import athlete from './modules/athlete';
import video_player from './modules/video_player';
import competition_list from './modules/competition_list';
import athlete_summary from './modules/athlete_summary';
import training from './modules/training';
import cookieConsent from './modules/cookieConsent';

export default createStore({
    modules: {
        competition,
        competition_users,
        competition_list,
        user,
        round,
        athlete,
        video_player,
        athlete_summary,
        training,
        cookieConsent
    }
});